(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-holistic"] && !Shopify.designMode) return;
  try {
    
(function () {
  const form = document.getElementById('AffiliateForm');
  if (!form) return;

  const fields = [
    { id: 'AffiliateForm-first-name', error: 'first-name-error', message: 'First name is required' },
    { id: 'AffiliateForm-last-name', error: 'last-name-error', message: 'Last name is required' },
    { id: 'AffiliateForm-email', error: 'email-error', message: 'Enter a valid email address', type: 'email' },
    { id: 'AffiliateForm-message', error: 'message-error', message: 'Please tell us about yourself' }
  ];

  function validateField(fieldConfig) {
    const input = document.getElementById(fieldConfig.id);
    const error = document.getElementById(fieldConfig.error);

    if (!input || !error) return true;

    let isValid = true;

    if (!input.value.trim()) {
      isValid = false;
    }

    if (fieldConfig.type === 'email') {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(input.value.trim())) {
        isValid = false;
      }
    }

    error.textContent = isValid ? '' : fieldConfig.message;
    input.setAttribute('aria-invalid', !isValid);

    return isValid;
  }

  fields.forEach(field => {
    const input = document.getElementById(field.id);
    if (!input) return;

    input.addEventListener('blur', () => validateField(field));
    input.addEventListener('input', () => {
      document.getElementById(field.error).textContent = '';
      input.removeAttribute('aria-invalid');
    });
  });

  form.addEventListener('submit', function (e) {
    let isFormValid = true;

    fields.forEach(field => {
      if (!validateField(field)) {
        isFormValid = false;
      }
    });

    if (!isFormValid) {
      e.preventDefault();
      form.querySelector('.affiliate-holistic__form-error')?.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
